import { Grid } from "@mui/material";
import { Typography } from "@pmag/ui-components";
import { type GQLComponentGroupWPArticleFragment } from "@src/graphql.generated";
import { useGlobalState } from "@src/hooks/useGlobalState";
import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";

import {
    WPArticleItem,
    WPArticleItemChip,
    WPArticleItemImage,
    WPArticleItemImageContainer,
    WPArticleItemImageInnerContainer,
    WPArticleItemInnerContainer,
    WPArticleItemName,
} from "./WPArticleGrid.styles";

export const dataTestId = {
    grid: "sparePartsFinder.overview.list.grid",
    article: "sparePartsFinder.overview.list.article",
    oemChip: "sparePartsFinder.overview.article.oemChip",
    description: "sparePartsFinder.overview.article.description",
};

export interface WPArticleGridProps {
    articles: GQLComponentGroupWPArticleFragment[];
}

export const WPArticleGrid: FunctionComponent<WPArticleGridProps> = ({ articles }) => {
    const { setModelId, setContextArticleId, modelId } = useGlobalState();

    return (
        <Grid
            container
            columns={{
                lg: 12,
                md: 12,
                sm: 8,
                xl: 12,
                xs: 4,
            }}
            spacing={4}
            data-testid={dataTestId.grid}
        >
            {articles.map(
                (article) =>
                    article.articleNumber && (
                        <WPArticleItem
                            item
                            key={article.id}
                            xs={2}
                            sm={2}
                            md={4}
                            lg={3}
                            xl={3}
                            data-id={article.id}
                            onClick={() => {
                                setContextArticleId(modelId);
                                setModelId(article.id || "");
                            }}
                            data-testid={dataTestId.article}
                        >
                            <WPArticleItemInnerContainer>
                                <WPArticleItemImageContainer>
                                    {article.isOem && (
                                        <WPArticleItemChip>
                                            <Typography variant="body-short-01" data-testid={dataTestId.oemChip}>
                                                <FormattedMessage id="sparePartsFinder.overview.article.oemPart" defaultMessage="OEM part" />
                                            </Typography>
                                        </WPArticleItemChip>
                                    )}

                                    <WPArticleItemImageInnerContainer>
                                        <WPArticleItemImage src={article.assetPath || ""} />
                                    </WPArticleItemImageInnerContainer>
                                </WPArticleItemImageContainer>

                                <WPArticleItemName>
                                    <Typography variant="heading-08" data-testid={dataTestId.description}>
                                        {article.description}
                                    </Typography>
                                </WPArticleItemName>
                            </WPArticleItemInnerContainer>
                        </WPArticleItem>
                    ),
            )}
        </Grid>
    );
};
